/* extra imports that the dynamic bundles, like the blocks use, but are not used anywhere in the main bundle */
import 'bootstrap';

import 'ef/models/survey';
import 'lib/languages';

/* includes some foundational block code in the everfi-sdk.js bundle */
import 'views/block';
import 'services';
import 'views/atoms';
